<div class="w-full relative">
  <img src="/footer1.png" alt="Sextou" class="w-full h-auto" />

  <button
    onclick="window.open('https://www.instagram.com/somosredal/', '_blank')"
    class="absolute top-[20%] right-[12%] sm:top-[30%] sm:right-[14%] md:top-[35%] md:right-[16%] lg:top-[38%] lg:right-[17%] w-7 h-7 sm:w-8 sm:h-8 md:w-9 md:h-9 rounded"
    aria-label="Instagram REDAL">
  </button>
</div>
